import styled from "styled-components";
import { Input } from "antd";

export const MarkdownContent = styled.div`
  p {
    margin: 0 0 8px 0;
    &:last-child {
      margin-bottom: 0;
    }
  }

  strong {
    font-weight: 600 !important;
    color: ${({ theme }) => theme.colors.primary || "#1890ff"};
  }

  ul, ol {
    margin: 8px 0;
    padding-left: 20px;
  }

  li {
    margin: 4px 0;
  }

  code {
    background: ${({ theme }) => theme.colors.backgroundSecondary || "#f5f5f5"};
    padding: 2px 6px;
    border-radius: 3px;
    font-family: monospace;
    font-size: 0.9em;
  }

  pre {
    background: ${({ theme }) => theme.colors.backgroundSecondary || "#f5f5f5"};
    padding: 12px;
    border-radius: 6px;
    overflow-x: auto;
  }

  blockquote {
    border-left: 3px solid ${({ theme }) => theme.colors.primary || "#1890ff"};
    padding-left: 12px;
    margin: 8px 0;
    color: ${({ theme }) => theme.colors.textSecondary || "#666"};
  }
`;

export const ComposerFooter = styled.div`
  padding: 24px 28px 28px;
  background: ${({ theme }) => theme.settings.whiteColor};
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  display: flex;
  justify-content: center;
`;

export const ComposerInner = styled.div`
  width: 100%;
`;

export const ComposerShell = styled.div`
  flex: 1;
  position: relative;
  border-radius: 999px;
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  background: ${({ theme }) => theme.settings.whiteColor};
  min-height: 52px;
  padding: 12px 64px 12px 16px;
  box-shadow: 0px 6px 29px rgba(89, 108, 148, 0.07), 0px 0.751px 3.631px rgba(89, 108, 148, 0.04);
  display: flex;
  align-items: center;
`;

export const StyledTextArea = styled(Input.TextArea).attrs({
  autoSize: { minRows: 1, maxRows: 4 },
  bordered: false,
})`
  && {
    width: 100%;
    background: transparent;
  }

  && textarea {
    border: none !important;
    box-shadow: none !important;
    resize: none !important;
    background: transparent !important;
    padding: 0 !important;
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 14px;
    line-height: 22px;
    color: ${({ theme }) => theme.settings.primary};
  }

  && textarea::placeholder {
    color: #9CA3AF;
    opacity: 1;
  }

  && textarea:focus {
    outline: none;
  }
`;

export const ComposerSendButton = styled.button`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: none;
  background: #3d2969;
  color: ${({ theme }) => theme.settings.whiteColor};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  cursor: pointer;
  box-shadow: inset 0px 4px 10px rgba(119, 88, 175, 0.6), 0px 8px 24px rgba(61, 41, 105, 0.25);
  transition: transform 0.2s ease, opacity 0.2s ease;

  &:hover:not(:disabled) {
    transform: translateY(-50%) translateY(-1px);
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const HeaderToggleButton = styled.button`
  height: 32px;
  border-radius: 6px;
  border: none;
  background: ${({ $isActive }) => $isActive ? '#3d2969' : '#3d2969'};
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  padding: 0 12px;
  transition: all 0.2s ease;
  flex-shrink: 0;
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  box-shadow: 0 2px 6px rgba(61, 41, 105, 0.2);

  svg {
    font-size: 12px;
    display: flex;
    align-items: center;
  }

  span {
    display: flex;
    align-items: center;
  }

  &:hover {
    background: #2d1f4e;
    box-shadow: 0 3px 10px rgba(61, 41, 105, 0.3);
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const TargetAudienceFormWrapper = styled.div`
  margin-top: 24px;
  margin-bottom: 16px;
  animation: slideDown 0.3s ease-out;

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const ChatPanelStyles = styled.div`
  .messageHeader {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    gap: 8px !important;
    width: 100% !important;
  }

  .messageHeaderLeft {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
  }
`;
